import Icon from '../components/Icon.vue'

Icon.register({
  spider: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M151.2 167.4L177.1 176H181.8L187 149.9C187.7 146.3 188.8 142.3 190.2 138.1L169.9 97.5 193.7 26.1C196.5 17.7 192 8.7 183.6 5.9L168.4 0.8C160-2 151 2.6 148.2 10.9L122.3 88.6A32-32 0 0 1 124 113.1L151.2 167.4zM573.3 349.4L520.6 270.3A32-32 0 0 1 493.9 256H416L485 231.7A32-32 0 0 1 501.5 219L555.1 138.6C560 131.3 558 121.3 550.7 116.4L537.4 107.6C530 102.7 520.1 104.6 515.2 112L464.6 187.8 404.1 208H368L357.6 156.1C355.4 145.2 340.3 96 288 96 235.7 96 220.6 145.2 218.4 156.1L208 208H171.9L111.4 187.8 60.8 112C55.9 104.6 46 102.7 38.6 107.6L25.3 116.4C18 121.3 16 131.3 20.9 138.6L74.5 219A32-32 0 0 1 91 231.7L160 256H82.1A32-32 0 0 1 55.4 270.3L2.7 349.4C-2.2 356.7-0.2 366.7 7.1 371.6L20.4 380.4C27.8 385.4 37.7 383.4 42.6 376L90.6 304H137.7L76.9 401.3A32-32 0 0 1 72 418.3V496C72 504.8 79.2 512 88 512H104C112.8 512 120 504.8 120 496V422.9L194.1 304.4C193.1 318.4 192 332.5 192 346.6 192 399.6 232.8 448 288 448S384 399.6 384 346.6C384 332.5 382.9 318.4 381.9 304.4L456 422.9V496C456 504.8 463.2 512 472 512H488C496.8 512 504 504.8 504 496V418.3C504 412.3 502.3 406.4 499.1 401.3L438.3 304H485.4L533.4 376C538.3 383.4 548.2 385.3 555.6 380.4L568.9 371.6C576.2 366.7 578.2 356.7 573.3 349.4zM406.1 97.5L385.8 138.1C387.2 142.3 388.3 146.3 389 149.9L394.2 176H398.9L424.8 167.4 452 113.1A32-32 0 0 1 453.7 88.6L427.8 10.9C425 2.6 416-2 407.6 0.8L392.4 5.9C384 8.7 379.5 17.7 382.3 26.1L406.1 97.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/spider.js
// module id = lTX4
// module chunks = 144